import { useEffect, useState, useRef } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { AuthLayout } from "@/components/AuthLayout";
import { authVerifyEmail, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { RefreshCw, CheckCircle2, XCircle } from "lucide-react";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [status, setStatus] = useState("verifying"); // verifying | ok | error
  const [message, setMessage] = useState("");
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    if (!token) { setStatus("error"); setMessage("This confirmation link is missing its token."); return; }
    authVerifyEmail(token)
      .then((r) => { setStatus("ok"); setMessage(r.message); })
      .catch((err) => { setStatus("error"); setMessage(formatApiError(err.response?.data?.detail) || err.message); });
  }, [token]);

  return (
    <AuthLayout>
      <div className="text-center" data-testid="verify-page">
        {status === "verifying" && (
          <>
            <RefreshCw size={30} className="text-[#2F6DA3] animate-spin mx-auto mb-5" />
            <h1 className="font-display text-2xl font-extrabold tracking-tight">Confirming your email…</h1>
          </>
        )}
        {status === "ok" && (
          <>
            <div className="inline-flex bg-emerald-50 border-2 border-emerald-200 p-4 mb-5"><CheckCircle2 size={30} className="text-emerald-600" /></div>
            <h1 className="font-display text-3xl font-extrabold tracking-tight mb-2" data-testid="verify-ok">Email confirmed</h1>
            <p className="text-sm text-zinc-500 mb-6">{message}</p>
            <Link to="/login"><Button className="bg-[#2F6DA3] hover:bg-[#234E74] text-white font-bold uppercase tracking-wider px-8 py-5" data-testid="verify-to-login">Log in</Button></Link>
          </>
        )}
        {status === "error" && (
          <>
            <div className="inline-flex bg-red-50 border-2 border-red-200 p-4 mb-5"><XCircle size={30} className="text-red-600" /></div>
            <h1 className="font-display text-2xl font-extrabold tracking-tight mb-2" data-testid="verify-error">Couldn't confirm email</h1>
            <p className="text-sm text-zinc-500 mb-6">{message}</p>
            <Link to="/login"><Button variant="outline" className="border-2 border-[#14304F] font-bold uppercase tracking-wider">Back to login</Button></Link>
          </>
        )}
      </div>
    </AuthLayout>
  );
}
